import {Component, OnInit, Input } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import {Feed} from '../../../models/feed';
import {Answer} from '../../../models/answer'
import {FeedService} from '../../../services/feed.service';
import {AuthService} from '../../../services/auth.service';
import filestack from 'filestack-js';

import { ModalFeedComponent } from '../modal-feed/modal-feed.component';

export class Comment {

    public id: number;
    public comment: string;

    constructor() {
    }

    populate(data): Comment {
        this.id = data.id;
        this.comment = data.comment;
        return this;
    }
}

declare var $: any;
import Swal from 'sweetalert2';

const apikey = 'A7zJTtgFRW6cWqHglvjIgz';
const client = filestack.init(apikey);

@Component({
  selector: 'app-clientes-feed-comments',
  templateUrl: './comments.component.html',
  styleUrls: ['../../userpanel.component.css'],
  providers: [FeedService, AuthService]
})

export class FeedCommentsComponent implements OnInit {

    @Input() comment;
    @Input() user;
    @Input() client;
    public formComment: FormGroup;
    public formAnswer: FormGroup;
    public update = false;
    public erase = false;
    public asker = false;

    constructor(
        public fb: FormBuilder,
        private feedService: FeedService
    ) {
        this.buildForm();
    }

    buildForm(): void {
        this.formComment = this.fb.group({
            comment: ['', Validators.minLength(5)],
        });
        this.formAnswer = this.fb.group({
            answer: ['', Validators.minLength(5)],
        });
    }

    ngOnInit() {
        let _this = this;

        this.feedService.feedChannel
        .bind('my-event-' + this.client, function (result) {
            if (result.type === 'delete') {
                this.erase = true;
            }


        });
    }

    OnAnswer(id: number): void {
        this.feedService.publishNewAnswer(this.prepareAnswer(id)).subscribe(res => {
           this.formAnswer.reset();
           this.asker = false;
        })
    }

    OnUpdateComment(id: number): void {
        this.feedService.updateComment(this.prepareComment(id))
        .subscribe(res => {
          this.comment.comment = res.data.comment
        });
        this.update = false;
      }


    deleteComment(id) {
        Swal.fire({
            title: 'Você quer apagar o item?',
            text: 'Você não poderá reverter essa ação depois de confirmado',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then(
            (result) => {
                if (result.value) {
                    this.feedService.deleteComment(id).subscribe(
                        res => {
                            this.erase = true;
                        }
                    )                    
                }

            },
            (cancel) => {}
        );
    }

    prepareComment(id: number): Comment {
        const formModel = this.formComment.value;
        const obj = new Comment();
        obj.comment = formModel.comment;
        obj.id = id;
        return obj;
    }

    prepareAnswer(id: number): Answer {
        const formModel = this.formAnswer.value;
        const obj = new Answer();
        obj.answer = formModel.answer;
        obj.comment_feed_id = id;
        return obj;
    }

    askComment(event) {
        this.asker == false ? this.asker = true : this.asker = false;
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/feed/comments/comments.component.ts